module.exports = __webpack_public_path__ + "media/images/light_yellow_slant-daa64827a45ed12ff477d2add6bacb39.png";